module.exports = __webpack_public_path__ + "static/media/logo_airportr.e47c8392.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_airportr.svg
// module id = 136
// module chunks = 0